import { CountryInfo } from './countryInfo';

export const COUNTRY_INFO_ACTIONS = {
  SET_COUNTRY_INFO: 'SET_COUNTRY_INFO'
};

export const setCountryInfo = (countryInfo: CountryInfo) => {
  return {
    type: COUNTRY_INFO_ACTIONS.SET_COUNTRY_INFO,
    data: countryInfo
  };
};
